import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/coupons";

const couponApi = {
  couponList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  couponActionLogList(params: any): Promise<any> {
    const url = `${path}/action-logs`;
    return api.get(url, params);
  },
};

export default couponApi;
